import React, {Component} from 'react';
import ListaTabla from './Includes/ListaTabla';
import ModalGoogleDrive from './Includes/ModalGoogleDrive';
import ModalFolder from './Includes/ModalFolder';

import {GoogleDriveService} from '../../../services/GoogleDriveService/GoogleDriveService';
import {FieldsJs} from "../../../settings/General/General";
import {ReactLocalStorageService} from '../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import VistaVacia from "../../Include/VistaVacia/VistaVacia";

import IntegrationNotistack, {ShowSnackBarsNotistack} from "../../../settings/IntegrationNotistack/IntegrationNotistack";
import {CreateNewFolder, Sync} from "@material-ui/icons";
import Fab from "@material-ui/core/Fab";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";


class GoogleDrive extends Component {
	
	state = {};
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		this.state = {
			archivos: [],
			routes: [],
			ruta_actual: '',
			item_id_actual: null
		};
		
		this.Listar();
	}
	
	showSnackBars = (type, message) => {
		ShowSnackBarsNotistack(this.props, type, message, null);
	};
	
	RefreshList = () => {
		this.Listar(this.state.ruta_actual, null, this.state.item_id_actual, true);
	};
	
	Listar = (ruta, name, item_id, keepRoutes) => {
		if (!keepRoutes) {
			if (ruta || item_id) {
				let rutas = FieldsJs.Copy(this.state.routes) || [];
				let index = -1;
				
				for (let i = 0; i < rutas.length; i++) {
					if ((item_id && rutas[i].item_id === item_id) || (ruta && rutas[i].path_display === ruta)) {
						index = i;
						break;
					}
				}
				
				if (index >= 0) {
					rutas.splice(index + 1);
				} else {
					rutas.push({
						path_display: ruta,
						name: name,
						item_id: item_id
					});
				}
				
				this.setState({
					routes: rutas,
					ruta_actual: ruta || '',
					item_id_actual: item_id || null
				});
			} else {
				this.setState({
					routes: [],
					ruta_actual: '',
					item_id_actual: null
				});
			}
		}
		
		GoogleDriveService.Listar(ruta, item_id).then((response) => {
			let data = response.data || {};
			this.setState({
				archivos: data.entries || []
			});
		}).catch((error) => {
			this.setState({
				archivos: []
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	descargarArchivo = (item) => {
		if (item.tipo === 'folder') {
			this.showSnackBars('error', 'No es posible descargar una carpeta.');
			return;
		}
		
		GoogleDriveService.Descargar({
			item_id: item.item_id,
			ruta: item.path_display || item.ruta,
			nombre: item.nombre || item.name,
			incluir_contenido: !item.download_url
		}).then((response) => {
			let data = response.data || {};
			
			if (data.download_url) {
				window.open(data.download_url, '_blank');
				return;
			}
			
			if (data.archivo) {
				let byteCharacters = atob(data.archivo);
				let byteNumbers = new Array(byteCharacters.length);
				for (let i = 0; i < byteCharacters.length; i++) {
					byteNumbers[i] = byteCharacters.charCodeAt(i);
				}
				let blob = new Blob([new Uint8Array(byteNumbers)], {type: data.mime_type || 'application/octet-stream'});
				let url = URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = url;
				link.download = data.nombre || item.nombre || item.name || 'archivo';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url);
				return;
			}
			
			this.showSnackBars('error', 'No se encontró el archivo para descargar.');
		}).catch((error) => {
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	compartirArchivo = (item) => {
		GoogleDriveService.Compartir({
			item_id: item.item_id,
			tipo: 'view'
		}).then((response) => {
			let data = response.data || {};
			let url = data.public_url || data.web_url || '';
			
			if (url) {
				let input = document.createElement('input');
				input.value = url;
				document.body.appendChild(input);
				input.select();
				document.execCommand('copy');
				document.body.removeChild(input);
				this.showSnackBars('success', 'Enlace copiado: ' + url);
			} else {
				this.showSnackBars('success', response.mensaje);
			}
		}).catch((error) => {
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	render() {
		
		return (
			<div className='Catalogos ContaineViewComponet'>
				<Grid container direction="row" justify="space-between" alignItems="center" spacing={2}
				      style={{marginTop: 20, marginBottom: 20}}>
					<Grid item>
						<div className={'vertical-inline w-100'}>
							<Typography variant={'h5'} className={'v-center text-left cursor-pointer'} onClick={() => this.Listar()}>
								Google Drive
							</Typography>
							{this.state.routes.map((item, key) => (
								<p key={key} className={'v-center margin-0 cursor-pointer'} style={{color: 'rgb(142, 30, 50)'}} onClick={() => this.Listar(item.path_display, item.name, item.item_id)}>/{item.name}</p>
							))}
						</div>
					</Grid>
					<Grid item>
						<Grid container direction="row" justify="flex-end" alignItems="center" spacing={2}>
							<Grid item>
								<ModalFolder
									tipo={'add'}
									item={{}}
									ruta={this.state.ruta_actual}
									parent_id={this.state.item_id_actual}
									RefreshList={this.RefreshList}
									showSnackBars={this.showSnackBars}
									componente={
										<Fab variant="extended" size="small" color="primary" style={{backgroundColor: "#8e1e32"}}>
											<CreateNewFolder style={{fontSize: 14, marginRight: 5}}/> Nueva carpeta
										</Fab>
									}
								/>
							</Grid>
							<Grid item>
								<Fab variant="extended" size="small" color="primary" style={{backgroundColor: "#3f50b6"}} onClick={() => this.RefreshList()}>
									<Sync style={{fontSize: 14, marginRight: 5}}/> Actualizar
								</Fab>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				
				<div className={'form margin-30-B'}>
					
					{this.state.archivos.length > 0 ? (
						<ListaTabla
							lista={this.state.archivos}
							gerContentFile={this.Listar}
							descargarArchivo={this.descargarArchivo}
							compartirArchivo={this.compartirArchivo}
							RefreshList={this.RefreshList}
							showSnackBars={this.showSnackBars}
						/>
					) : (
						<VistaVacia
							numero={0}
							mensaje={'No se encontraron datos.'}
						/>
					)}
				
				</div>
				
				<ModalGoogleDrive
					tipo={'add'}
					item={{}}
					ruta={this.state.ruta_actual}
					parent_id={this.state.item_id_actual}
					RefreshList={this.RefreshList}
					showSnackBars={this.showSnackBars}
				/>
			
			</div>
		);
	}
}

GoogleDrive.propTypes = {};

export default IntegrationNotistack(GoogleDrive);
